import $ from 'jquery';
import scrollbarWidth from 'scrollbarwidth';
import Prefixed from 'modules/prefixed/prefixed';

export default class {
	constructor(options) {
		const defaults = {
			el: false,
			dom: {
				overlay: '.js-overlay',
				fixed: '.js-overlay-fixed',
				onfixed: '.js-overlay-onfixed',
				open: '.js-overlay-open',
				close: '.js-overlay-close',
				header: '#header, .js-overlay-right'
			},
			classes: {
				state: {
					open: 'b-overlay_state_open',
					back: 'b-overlay_state_back'
				},
				body: {
					open: 'on-overlay'
				}
			},
			callback: {
				open: false,
				close: false
			}

		};

		this.options = $.extend(true, {}, defaults, options);
		this.$el = (this.options.el instanceof $) ? this.options.el : $(this.options.el);
		this.$overlay = $(this.options.dom.overlay);
		this.$document = $(document);
		this.overlays = [];
		this.scrollbarWidth = scrollbarWidth();
		this.prefixed = new Prefixed();
		this.setCallback(this.options.callback);
		return this;
	}

	setCallback(callback) {
		if (this.$el.length) {
			this.$el.data('callback', callback);
		} else {
			this.$overlay.data('callback', callback);
		}
	}

	callback($overlay, type) {
		const callback = $overlay.data('callback');
		if (callback) {
			if (typeof callback[type] === 'function') {
				callback[type]();
			}
		}
	}

	getDom() {
		this.$html = $('html');
		this.$body = $(document.body);
		this.$window = $(window);
		this.$htmlBody = this.$html.add(this.$body);

		this.$htmlBody.attr('style', 'height: auto !important;');

		this.$open = $(this.options.dom.open);
		this.$close = $(this.options.dom.close);
		this.$fixed = this.$overlay.find(this.options.dom.fixed);
		this.$onfixed = $(this.options.dom.onfixed);
		this.$closed = this.$close.filter(function () {return $(this).css('position') === 'fixed';});
		this.$header = $(this.options.dom.header);
	}

	onClick(type, event) {
		const $target = $(event.currentTarget);
		let $overlay = {length: 0};
		if (type === 'opened') {
			$overlay = this.$overlay.filter('#' + $target.data('overlay'));
		} else {
			$overlay = $target.closest(this.options.dom.overlay);
		}
		if ($overlay.length) {
			$overlay.trigger('yota.overlay.' + type);
		}
	}

	open(event) {
		const self = this;
		let inArray = false;
		const $overlay = $(event.currentTarget);
		if (!$overlay.hasClass(self.options.classes.state.back)) {
			$overlay.scrollTop(0);
		}
		if (self.overlays.length) {
			$.each(self.overlays, function (key, $item) {
				if ($item.is($overlay)) {
					inArray = true;
				}
				$item.toggleClass(self.options.classes.state.back, !$item.is($overlay));
			});
		}
		$overlay.addClass(self.options.classes.state.open);

		if (!inArray) {
			self.overlays.push($overlay);
		}
		self.$htmlBody.addClass(self.options.classes.body.open);
		self.$header.css({marginRight: self.scrollbarWidth});
		self.$onfixed.css({marginRight: self.scrollbarWidth});
		self.$closed.css({marginRight: self.scrollbarWidth});
		self.$body.css({paddingRight: self.scrollbarWidth});
		self.$window.trigger('yota.overlay.open');
		self.callback($overlay, 'open');
		if (typeof this.options.callback.open === 'function') {
			this.options.callback.open();
		}
		this.$document.trigger('yota.document.overlay.open');
		return this;
	}

	close(event) {
		const $overlay = $(event.currentTarget);
		this.overlays.splice(-1, 1);
		$overlay
			.one(this.prefixed.events.transitionEnd, this.onTransitionEnd.bind(this))
			.removeClass(this.options.classes.state.open);
		this.$document.trigger('yota.document.overlay.close');
		return this;
	}

	onTransitionEnd(event) {
		const $overlay = $(event.currentTarget);
		const self = this;
		if (self.overlays.length) {
			self.overlays[self.overlays.length - 1].removeClass(self.options.classes.state.back);
			self.$window.trigger('yota.overlay.open');
			self.callback(self.overlays[self.overlays.length - 1], 'open');
			self.callback($overlay, 'close');
		} else {
			setTimeout(function () {
				self.$htmlBody.removeClass(self.options.classes.body.open);
				self.$header.css({marginRight: 0});
				self.$body.css({paddingRight: 0});
				self.$onfixed.css({marginRight: 0});
				self.$window.trigger('yota.overlay.close');
				self.callback($overlay, 'close');
			}, 250);
		}
	}

	active() {
		return this.$overlay.filter('.' + this.options.classes.state.open + ':not(.' + this.options.classes.state.back + ')');
	}

	isActive() {
		let active = false;
		if (this.$overlay.length) {
			active = this.$el.hasClass(this.options.classes.state.open);
		}
		return active;
	}

	hasActive() {
		let active = false;
		if (this.$overlay.length) {
			active = this.$overlay.filter('.' + this.options.classes.state.open).length > 0;
		}
		return active;
	}

	render() {
		if (this.$overlay.length) {
			this.getDom();
			this.$open.on('click', this.onClick.bind(this, 'opened'));
			this.$close.on('click', this.onClick.bind(this, 'closed'));
			this.$overlay.on('yota.overlay.open', this.open.bind(this));
			this.$overlay.on('yota.overlay.close', this.close.bind(this));
			this.$overlay.on('yota.overlay.opened', this.open.bind(this));
			this.$overlay.on('yota.overlay.closed', this.close.bind(this));
			this.$fixed.css({right: this.scrollbarWidth});
		}
	}
}



// WEBPACK FOOTER //
// ./app/blocks/overlay/overlay.js